import React from 'react';
import Page from 'components/Page';
import { useLanguage } from 'context/AppContext';
import * as Styles from './HomePage.styles';

const HomePage: React.FC = () => {
  const [language] = useLanguage();

  return (
    <Page>
      <Styles.HomePage>
        <h2>{language.HomePage.title}</h2>
        <Styles.Content>{language.HomePage.content}</Styles.Content>
      </Styles.HomePage>
    </Page>
  );
};

export default HomePage;
